import { ComplianceSummary } from 'store/assets/types';
import { AssetDelta, ClearAssetChanges } from 'store/changes/types';
import { AssetError } from 'store/error/types';
import { createAction } from 'typesafe-actions';

export const SET_ASSET_DELTA = createAction('@CHANGES/SET_ASSET_DELTA')<{
  id: string;
  delta: AssetDelta;
}>();

export const doAssetUpdateListItemComplianceSummary = createAction(
  'doAssetUpdateListItemComplianceSummary',
)<{
  assetId: string;
  complianceId: string;
  complianceSummary: ComplianceSummary;
}>();

export const CLEAR_LOCAL_CHANGES = createAction(
  '@CHANGES/CLEAR_LOCAL_CHANGES',
)<{
  timestamp: number;
  asset_errors: Record<string, AssetError> | undefined;
}>();

export const CLEAR_LOCAL_ASSET_CHANGES = createAction(
  '@CHANGES/CLEAR_LOCAL_ASSET_CHANGE',
)<ClearAssetChanges>();
